/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CountryCodeResource } from './';
import {
    CountryCodeResourceFromJSON,
    CountryCodeResourceFromJSONTyped,
    CountryCodeResourceToJSON,
} from './';
import type { PricingPlanResource } from './';
import {
    PricingPlanResourceFromJSON,
    PricingPlanResourceFromJSONTyped,
    PricingPlanResourceToJSON,
} from './';
import type { ServiceLevelResource } from './';
import {
    ServiceLevelResourceFromJSON,
    ServiceLevelResourceFromJSONTyped,
    ServiceLevelResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceLevelDetailResource
 */
export interface ServiceLevelDetailResource {
    /**
     * 
     * @type {Array<CountryCodeResource>}
     * @memberof ServiceLevelDetailResource
     */
    countries?: Array<CountryCodeResource>;
    /**
     * 
     * @type {Array<PricingPlanResource>}
     * @memberof ServiceLevelDetailResource
     */
    pricingPlans?: Array<PricingPlanResource>;
    /**
     * 
     * @type {ServiceLevelResource}
     * @memberof ServiceLevelDetailResource
     */
    serviceLevel?: ServiceLevelResource;
}

/**
 * Check if a given object implements the ServiceLevelDetailResource interface.
 */
export function instanceOfServiceLevelDetailResource(value: object): value is ServiceLevelDetailResource {
    return true;
}

export function ServiceLevelDetailResourceFromJSON(json: any): ServiceLevelDetailResource {
    return ServiceLevelDetailResourceFromJSONTyped(json, false);
}

export function ServiceLevelDetailResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelDetailResource {
    if (json == null) {
        return json;
    }
    return {
        
        'countries': json['countries'] == null ? undefined : ((json['countries'] as Array<any>).map(CountryCodeResourceFromJSON)),
        'pricingPlans': json['pricingPlans'] == null ? undefined : ((json['pricingPlans'] as Array<any>).map(PricingPlanResourceFromJSON)),
        'serviceLevel': json['serviceLevel'] == null ? undefined : ServiceLevelResourceFromJSON(json['serviceLevel']),
    };
}

export function ServiceLevelDetailResourceToJSON(value?: ServiceLevelDetailResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countries': value['countries'] == null ? undefined : ((value['countries'] as Array<any>).map((v) => CountryCodeResourceToJSON(v))),
        'pricingPlans': value['pricingPlans'] == null ? undefined : ((value['pricingPlans'] as Array<any>).map((v) => PricingPlanResourceToJSON(v))),
        'serviceLevel': ServiceLevelResourceToJSON(value['serviceLevel']),
    };
}

